import {Component, EventEmitter, Input, OnInit, Output, SimpleChanges} from '@angular/core';
import {
  fdeBloombergNavObject,
  fdeMorningStarNavObject,
  fdeClientRequestNavObject, fdeBloombergHoldingObject
} from '../../../../common/it-interface';
import {convertToSnakeCase} from "../../../../common/it-utils";
import {SIDE_NAV_TITLES} from "../../../../common/it-constants";

@Component({
  selector: 'app-fde-nav-report',
  templateUrl: './fde-nav-report.component.html',
  styleUrls: ['./fde-nav-report.component.scss']
})
export class FdeNavReportComponent implements OnInit{

  @Input() listOfFdeBbgNavByHstDate: fdeBloombergNavObject[];
  @Input() listOfFdeMsNavByHstDate: fdeMorningStarNavObject[];
  @Input() listOfFdeCrNavByHstDate: fdeClientRequestNavObject[];
  @Input() listOfBbgHoldingByHstDate: fdeBloombergHoldingObject[];
  @Input() subLoading: boolean;

  fundDayEndReportKey = convertToSnakeCase(SIDE_NAV_TITLES.fundDayEndReport);

  loading: true

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {

  }
}
